import { FormBuilder, FormGroup } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import {
  PetitumRevisioneAdapter
} from '../../components/fascicolo/sezione-economica-valore-add-revisione/petitum-revisione-adapter';
import { PetitumRevisione } from '../../models/petitum-revisione';
import { BaseForm } from '../base-Form';

export abstract class ValoreEconomicoCostiGestioneFormComponent extends BaseForm {

  request: PetitumRevisione;
  petitumRevisioneForm: FormGroup;

  abstract getPetitumRevisione(): PetitumRevisione;
  abstract getRequest(request: PetitumRevisione);

  constructor(
    protected operationService: OperationsService,
    protected campiForm: FormBuilder,
    protected helpers: HelpersService) {
    super();
  }

 initRequest() {
    this.request = new PetitumRevisioneAdapter(this.getPetitumRevisione()).petitumRevisione;
  }

  createForm() {
      this.initRequest();
      this.petitumRevisioneForm = this.campiForm.group({
      dataRevisioneDa: [this.request.dataRevisioneDa],
//      costiGestione: [this.request.costiGestione],
      compensi: [this.request.compensi],
      spese: [this.request.spese],
      altro: [this.request.altro],
      motivoRevisione: [this.request.motivoRevisione]
    });
  }

  populateSelect() {}

  save() {
    this.getRequest(this.request);
  }
}
